import { BaseResource } from '../core/base-resource';

export class Sponsor extends BaseResource {
  name: string;
}
